module.exports = __webpack_public_path__ + "641b15eb82acbf76dbb16ecc06356eb6.png";